<!-- COMMON ROW FOR ALL JOB TYPES-->

<div class="row no-gutters pt-3"
     *ngIf="!job.state || job.state === DistributionJobState.INITIAL">

   <div class="col-sm-12 col-md-6">
       <div class="row no-gutters">
           <div class="col-10">
               <mat-form-field class="full-width">
                   <mat-label>{{ job.trans.receiver | translate }}</mat-label>
                   <mat-select id="{{idPrefix}}{{job.trans.receiver}}"
                               [(ngModel)]="selectedReceiver"
                               (ngModelChange)="updateReceiver()"
                               [disabled]="disabled">
                       <mat-option *ngFor="let participant of receivers; let idx = index"
                                   id="{{idPrefix}}{{job.trans.receiver}}.item_{{idx}}"
                                   [value]="participant">
                           {{ (participant.actionListDisplayName ? (participant.actionListDisplayName + (participant.displayName ? ' - ' : '')) : '') + participant.displayName }}
                       </mat-option>
                   </mat-select>
               </mat-form-field>
           </div>

           <div class="col-2"></div>
       </div>
   </div>

   <div class="col-sm-12 col-md-6">
       <div class="row no-gutters">
           <div class="col-10">
               <mat-form-field class="full-width">
                   <mat-label>{{ job.trans.channel | translate }}</mat-label>
                   <mat-select id="{{idPrefix}}{{job.trans.channel}}"
                               [(ngModel)]="selectedChannel"
                               (ngModelChange)="updateChannel()"
                               [disabled]="disabled">
                       <mat-option *ngFor="let channel of channels; let idx = index"
                                   id="{{idPrefix}}{{job.trans.channel}}.{{channel.key}}"
                                   [value]="channel">
                           {{ channel.trans | translate }}
                       </mat-option>
                   </mat-select>
               </mat-form-field>
           </div>

           <div class="col-2"></div>
       </div>
   </div>

</div>

<!-- SPECIFIC INPUTS PER JOB TYPE -->
<div class="row no-gutters pt-3" [ngSwitch]="job.channel">

    <div class="col-12">

        <email-distribution-header #headerComponent
                                   class="full-width"
                                   *ngSwitchCase="DistributionJobChannel.EMAIL"
                                   [idPrefix]="idPrefix"
                                   [bananaBox]="job"
                                   [disabled]="isDisabled"
                                   (updated)="patchAndUpdateWithValue($event)"
                                   (multiUpdated)="patchOpDataArray($event)">
        </email-distribution-header>

        <insign-distribution-header #headerComponent
                                    class="full-width"
                                    *ngSwitchCase="DistributionJobChannel.SIGNING"
                                    [idPrefix]="idPrefix"
                                    [bananaBox]="job"
                                    [disabled]="isDisabled"
                                    (updated)="patchAndUpdateWithValue($event)"
                                    (multiUpdated)="patchOpDataArray($event)">
        </insign-distribution-header>

        <claims-net-distribution-header #headerComponent
                                        class="full-width"
                                        *ngSwitchCase="DistributionJobChannel.CLAIMNET"
                                        [idPrefix]="idPrefix"
                                        [bananaBox]="job"
                                        [disabled]="isDisabled"
                                        (updated)="patchAndUpdateWithValue($event)"
                                        (multiUpdated)="patchOpDataArray($event)">
        </claims-net-distribution-header>

    </div>

</div>

<div class="row no-gutters">
    <div class="col-12">
        <distribution-list class="full-width"
                           *ngIf="job.item || job.workflow_id"
                           [idPrefix]="idPrefix"
                           [jobState]="job.state"
                           [documents]="job.documentsArray"
                           [disabled]="isDisabled"
                           (update)="updateDocument($event)"
                           (view)="viewDocument($event)"
                           (delete)="removeDocument($event)">
        </distribution-list>
    </div>
</div>

<div class="row no-gutters"
     *ngIf="isCaseJob() && !isDisabled">
    <div class="col-12">
        <div class="smp-drop-zone no-cdk-drag-placeholder"
             [ngClass]="{'dragging-over': dragging}"
             cdkDropList
             [id]="'distributionList'"
             (cdkDropListDropped)="fileDropped($event)"
             (cdkDropListEntered)="draggingOver(true)"
             (cdkDropListExited)="draggingOver(false)">

            <span class="centered-span iq-link-style" >
                {{ 'detailed_processing.distribution.label.drag_n_drop_or_double_click' | translate }}
            </span>

        </div>
    </div>
</div>

<div class="row no-gutters mt-3">
    <div class="col-sm-6 col-md-3 offset-sm-0 offset-md-6 pr-1">
        <a mat-stroked-button
           color="primary"
           id="{{idPrefix}}btn.delete_job"
           class="full-width"
           *ngIf="cancelButtonAvailable"
          (click)="cancelJob()">
            <span>{{ 'common.btn.cancel' | translate | uppercase }}</span>
        </a>
    </div>

    <div class="col-sm-6 col-md-3 pl-1">
        <button *ngIf="prepareButtonAvailable"
                id="{{idPrefix}}btn.prepare_job"
                mat-flat-button color="accent" class="full-width"
                (click)="prepareJob()"
                [disabled]="prepareButtonDisabled">
            <span>{{ getPrepareButtonText() }}</span>
        </button>

        <button *ngIf="sendButtonAvailable"
                id="{{idPrefix}}btn.send_job"
                mat-flat-button color="accent" class="full-width"
                (click)="send.emit(job)">
            <span *ngIf="job.state === DistributionJobState.PREPARED">{{ 'detailed_processing.distribution.btn.finish_distribution' | translate | uppercase }}</span>
            <span *ngIf="job.state === DistributionJobState.ERROR_SENDING">{{ 'detailed_processing.distribution.btn.resend_distribution' | translate | uppercase }}</span>
        </button>

        <button *ngIf="signNowButtonAvailable"
                id="{{idPrefix}}btn.sign_now"
                mat-flat-button color="accent" class="full-width"
                (click)="signJob()"
                [disabled]="signNowButtonDisabled">
            <span>{{ 'detailed_processing.distribution.btn.sign_now' | translate | uppercase }}</span>
        </button>

        <button *ngIf="copyButtonAvailable"
                id="{{idPrefix}}btn.copy_job"
                mat-flat-button class="full-width iq-link-style"
                (click)="copy.emit(job)">{{ 'detailed_processing.distribution.btn.copy_distribution' | translate | uppercase }}
        </button>

        <a *ngIf="!isCaseJob()"
           id="{{idPrefix}}btn.add_documents_to_distribution_job"
           mat-button
           class="full-width"
           (click)="onOpenTemplatesDialog.emit()">
            {{ 'workflow_management.btn.add_documents_to_distribution_job' | translate | uppercase }}
        </a>
    </div>
</div>
